import { useQuery } from '@tanstack/react-query'
import {
  queries,
  useMealSummaries,
  useUserMeal,
  UserV1,
} from '@tovala/browser-apis-combinedapi'
import { userTermStatusesQuery } from './terms'

export function useMealDeepLinkMenuPath({
  isSubscriptionActive,
  mealID,
  user,
}: {
  isSubscriptionActive: boolean
  mealID: number | undefined
  user: UserV1
}): { isResolving: boolean; menuPath: string | null } {
  const hasMealID = mealID !== undefined

  const { data: userMeal, isLoading: isLoadingMeal } = useUserMeal({
    mealID,
    userID: user.id,
  })
  const meal = userMeal?.meal

  const { data: userTermStatuses, isLoading: isLoadingUserTermStatuses } =
    useQuery({
      ...userTermStatusesQuery({ user }),
      enabled: hasMealID && isSubscriptionActive,
    })

  const { data: publicTermStatuses, isLoading: isLoadingPublicTermStatuses } =
    useQuery({
      ...queries.termStatuses.public(),
      enabled: hasMealID && !isSubscriptionActive,
    })

  const termStatuses = isSubscriptionActive
    ? userTermStatuses
    : publicTermStatuses

  const openMealTerm = meal
    ? termStatuses?.find(
        (termStatus) =>
          termStatus.termID === meal.termID && termStatus.readyForView,
      )
    : undefined

  const { data: mealSummaries, isLoading: isLoadingMealSummaries } =
    useMealSummaries({ subTermID: openMealTerm?.selectedSubTermID })

  const isMealOnSelectedSubTerm = !!mealSummaries?.some(
    (mealSummary) => mealSummary.id === meal?.id,
  )

  const isResolving =
    isLoadingMeal ||
    isLoadingUserTermStatuses ||
    isLoadingPublicTermStatuses ||
    isLoadingMealSummaries

  return {
    isResolving,
    menuPath:
      meal && isMealOnSelectedSubTerm
        ? `/menu/${meal.termID}?meal=${meal.id}`
        : null,
  }
}
